import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const COLORES_ACCION = {
    Editar: '#1403fa',
    Eliminar: '#d93025',
    Observar: '#f0b400',
    Bloqueo: '#e08a00',
    VerDetalle: '#0f9bb5',
};

const GRIS_DESHABILITADO = '#808080';

/**
 * Botón de ícono para la columna "Acciones": cuadrado redondeado con el ícono a color
 * y un fondo suave al pasar el mouse. Con `outlined` se dibuja solo el borde.
 */
const AccionIconoButton = ({ icon, title, color, onClick, outlined = false, disabled = false }) => {
    const [hover, setHover] = useState(false);
    const colorFinal = disabled ? GRIS_DESHABILITADO : color;

    return (
        <button
            type="button"
            title={title}
            aria-label={title}
            onClick={disabled ? undefined : onClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '30px',
                height: '30px',
                marginRight: '6px',
                padding: 0,
                borderRadius: '8px',
                border: outlined ? `1.5px solid ${colorFinal}` : '1.5px solid transparent',
                backgroundColor: hover && !disabled ? `${colorFinal}1A` : 'transparent',
                color: colorFinal,
                cursor: disabled ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.15s',
            }}
        >
            <FontAwesomeIcon icon={icon} size="sm" color={colorFinal} />
        </button>
    );
};

export default AccionIconoButton;
